import { CONFIG } from './config'

class ExpertAnalysisService {
  constructor (env = 'develop') {
    this.baseUrl = CONFIG.baseUrl(env)
  }

  async subscribe (payload) {
    try {
      const response = await $fetch('/memberhub/expert-ease/subscribe', {
        method: 'POST',
        baseURL: `${this.baseUrl}`,
        canCancel: true,
        body: payload
      })
      return response
    } catch (error) {
      // OhMyFetch will call the error handler defined in the interceptor
      // You can handle the error here as well if needed
      return error
    }
  }
}

export default ExpertAnalysisService
